module.exports = __webpack_public_path__ + "img/haulageIcon.49cabe8a.svg";